import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';
import { computeBPS } from '../state.js';

let accumulator = 0;

export const autoGenerationSystem: TickSystem<GameState, GameAction> = {
  name: 'autoGeneration',
  update: (state, dt, _dispatch) => {
    if (!state.isRunning) return state;

    const bps = computeBPS(state);
    if (bps <= 0 && !state.starUpgrades['S4']) return state;

    accumulator += dt;
    if (accumulator < 0.1) return state; // tick every 100ms
    const elapsed = accumulator;
    accumulator = 0;

    let produced = bps * elapsed;

    // S4: auto-tap (1 tap/sec)
    // Handled in view layer, not here

    if (produced <= 0) return state;
    produced = Math.floor(produced);
    if (produced <= 0) return state;

    const newBPS = bps;

    return {
      ...state,
      beans: state.beans + produced,
      stats: {
        ...state.stats,
        totalBeans: state.stats.totalBeans + produced,
        totalBeansThisRun: state.stats.totalBeansThisRun + produced,
        peakBPS: Math.max(state.stats.peakBPS, newBPS),
      },
    };
  },
};
